<template>
  <div class="page">
    <a-card title="新建优惠券规则" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item prop="ruleName" label="规则名称">
          <a-input v-model="ruleForm.ruleName" :maxLength="10" placeholder="请输入"/>
        </a-form-model-item>
        <a-form-model-item prop="couponId" label="关联优惠券">
          <a-button @click="showSelectedDialog = true" style="margin-right:15px;">选择</a-button>
          <a-input style="max-width: 320px" v-model="ruleForm.couponId" :maxLength="20" disabled
                   placeholder="请输入关联优惠券ID"/>
        </a-form-model-item>
        <a-form-model-item label="自动生成规则" required>
          <a-col :span="6" style="margin-right:5px;">
            <a-cascader allowClear
                        :options="optionslist"
                        :value='defaultWayValue'
                        changeOnSelect placeholder="请选择自动生成规则"
                        @change="onGetWayChange"/>
          </a-col>
          <a-col :span="17">
            <a-form-model-item v-if="ruleForm.ruleType==1" prop="days" style="margin-bottom:0;">
              <span class="pr5">每</span>
              <a-select v-model="ruleForm.days" style="width: 100px">
                <a-select-option v-for="item in daysList" :key="item.value"> {{ item.value }}</a-select-option>
              </a-select>
              <span class="pl5">天，创建1次</span>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item label="领取时间" required>限生成当日领取</a-form-model-item>
        <a-form-model-item label="可用时间" prop="effectiveDays" required>
          <span class="pr5">生成当日</span>
          <a-select v-model="ruleForm.effectiveDays" style="width: 100px">
            <a-select-option v-for="item in daysList" :key="item.value"> {{ item.value }}</a-select-option>
          </a-select>
          <span class="pl5">天内可用</span>
        </a-form-model-item>
        <a-form-model-item prop="isLimit" label="数量">
          <a-col :span="5">
            <a-select allowClear v-model="ruleForm.isLimit" placeholder="请选择">
              <a-select-option :value="1">不限</a-select-option>
              <a-select-option :value="0">限量</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="16" class="pl5">
            <a-form-model-item v-if="ruleForm.isLimit==0" prop="count">
              <a-input v-model="ruleForm.count" addonAfter="张" placeholder="1-100000" :maxLength="6"
                       style="max-width:150px"/>
            </a-form-model-item>
          </a-col>
        </a-form-model-item>
        <a-form-model-item prop="couponGetDate" label="请选择规则有效期">
          <a-range-picker name="buildTime" :disabledDate="disabledDate"
                          v-model="ruleForm.couponGetDate"
                          @change="onDateGetDateChange" show-time
                          format="YYYY-MM-DD HH:mm:ss"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <template v-if="ruleId==0">
            <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
            <a-button @click="resetForm">取消</a-button>
          </template>
          <a-button v-if="ruleId>0&&status!=2" @click="overbtn">提前结束</a-button>
        </a-form-model-item>
      </a-form-model>
      <selected-product-dialog
        :show="showSelectedDialog"
        ref="pageList"
        :itemNames="['search_proName']"
        :query-params="selectedQueryParams"
        :requestPromise="loadPromise"
        @close="showSelectedDialog=false"
        :columns="getGoodsColumns()"
      >
        <a-form-item
          label="名称"
          slot="search_proName"
          v-bind="currentDialogLayout">
          <a-input
            v-model="selectedQueryParams.couponName"
            style="width: 170px"
            placeholder="请输入优惠券名称"
          ></a-input>
        </a-form-item>
        <template slot="action" slot-scope="rowItem">
          <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
        </template>
      </selected-product-dialog>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'NewRule',
  components: {
    SelectedProductDialog
  },
  data() {
    var checkNum = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) > Number(100000)) {
          callback(new Error('数量必须要小于100000'))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      moment,
      ruleId: this.$route.query.ruleId,
      status: this.$route.query.status,
      showSelectedDialog: false,
      submitLoading: false,
      defaultWayValue: [1],
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      selectedQueryParams: {
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponName: '', // 优惠券名称
        couponPlatformId: this.getPlatformConfig().platformId
      },
      loadPromise: params => this.getListPromise(params),
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 3 },
          md: { span: 5 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 21 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 21 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 3 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 5 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        isLimit: 1,
        couponGetDate: undefined,
        count: '',// 数量 ,
        couponId: '',// 关联优惠卷id ,
        days: 1,// 自然日 每多少天规则 ,
        effectiveDays: 1,// 有效时间(天数)
        effectiveEndTime: '',//有效结束时间
        effectiveStartTime: '',//有效开始时间
        ruleName: '',//规则名称 ,
        ruleType: 1,// 卷类型(1:自然日,2:星期轮回) ,
        weekDay: ''// 星期几(1-7)
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      rules: {
        ruleName: [
          { required: true, message: '请输入规则名称', trigger: 'blur' }
        ],
        couponId: [
          { required: true, message: '请输入关联优惠券ID', trigger: 'blur' }
        ],
        isLimit: [
          { required: true, message: '请输选择数量', trigger: 'blur' }
        ],
        count: [
          { required: true, message: '请选择限量数值', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正确的限量数值', trigger: 'blur' },
          { validator: checkNum, trigger: 'blur' }
        ],
        couponGetDate: [
          { required: true, message: '请选择规则有效期', trigger: 'change' }
        ]
      },
      daysList: [],
      optionslist: [
        {
          value: 1,
          label: '按自然日生成',
          children: []
        },
        {
          value: 2,
          label: '按星期生成',
          children: [
            {
              value: 1,
              label: '星期一'
            },
            {
              value: 2,
              label: '星期二'
            },
            {
              value: 3,
              label: '星期三'
            }, {
              value: 4,
              label: '星期四'
            },
            {
              value: 5,
              label: '星期五'
            },
            {
              value: 6,
              label: '星期六'
            },
            {
              value: 7,
              label: '星期日'
            }
          ]
        }
      ]
    }
  },
  mounted() {
  },
  activated() {
    this.getLogUtils().logWithTag('activated', 'activated')
    this.$store.commit('SET_RECHARGE', true)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CouponServiceList', title: '优惠券列表' },
      { name: 'CouponRuleList', title: '规则列表' }
    ])
    this.ruleId = this.$route.query.ruleId
    this.status = this.$route.query.status
    this.getDaysList()
    this.getCouponRuleData()
  },
  methods: {
    getDaysList() {
      let arr = []
      for (let i = 1; i <= 30; i++) {
        let obj = new Object()
        obj.value = i
        arr.push(obj)
      }
      this.daysList = arr
      this.getLogUtils().logWithTag('daysList', this.daysList)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingList', params)
    },
    onSelectedResult(data) {
      this.getLogUtils().logWithTag('==onSelectedResult==', data)
      this.ruleForm.couponId = data.couponId
      this.showSelectedDialog = false
    },
    getGoodsColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'couponId'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName'
        },
        {
          title: '面额',
          dataIndex: 'couponAmout'
        },
        {
          title: '类型',
          dataIndex: 'couponUseTypeStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    // 获取领取方式
    onGetWayChange(value, selectedOptions) {
      this.getLogUtils().logWithTag('value', value)
      this.getLogUtils().logWithTag('selectedOptions', selectedOptions)
      if (value && value.length) {
        if (value.length == 2) {
          this.defaultWayValue = [value[0], value[1]]
          this.ruleForm.ruleType = value[0]
          this.ruleForm.weekDay = value[1]
        } else {
          this.ruleForm.ruleType = value[0]
          this.defaultWayValue = [value[0]]
        }
      } else {
        this.defaultWayValue = []
      }

    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    //领取日期
    onDateGetDateChange(dates, dateStrArr) {
      this.getLogUtils().logWithTag('onDateGetDateChange', dates)
      this.getLogUtils().logWithTag('onDateGetDateChange', dateStrArr)
      this.ruleForm.couponGetDate = dates
      this.ruleForm.effectiveStartTime = dateStrArr[0]
      this.ruleForm.effectiveEndTime = dateStrArr[1]
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      delete this.submitFormData.couponGetDate
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('couponSettingRule/save', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('优惠券规则保存成功')
        setTimeout(() => {
          this.$router.push({
            name: 'CouponRuleList',
            query: {
              serverUniqueId: this.$route.query.serverUniqueId,
              updateFlag: true
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getCouponRuleData() {
      if (this.ruleId != 0) {
        this.getHttpServices().getServerApiService().post('couponSettingRule/getCouponRuleById/' + this.ruleId).then(res => {
          this.getLogUtils().logWithTag('getCouponRuleData', res)
          this.ruleForm = res
          this.ruleForm.couponGetDate = this.getDateHelper().getDateMoments(res.effectiveStartTime, res.effectiveEndTime)
          if (res.ruleType == 1) {
            this.defaultWayValue = [Number(res.ruleType)]
          } else {
            this.defaultWayValue = [Number(res.ruleType), Number(res.weekDay)]
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.defaultWayValue = [1]
        this.ruleForm = {
          isLimit: 1,
          couponGetDate: undefined,
          count: '',// 数量 ,
          couponId: '',// 关联优惠卷id ,
          days: 1,// 自然日 每多少天规则 ,
          effectiveDays: 1,// 有效时间(天数)
          effectiveEndTime: '',//有效结束时间
          effectiveStartTime: '',//有效开始时间
          ruleName: '',//规则名称 ,
          ruleType: 1,// 卷类型(1:自然日,2:星期轮回) ,
          weekDay: ''// 星期几(1-7)
        }
      }
    },
    // 提前结束
    overbtn() {
      this.getHttpServices().getServerApiService().post('couponSettingRule/closeCouponRuleById/' + this.ruleId).then(res => {
        this.getLogUtils().logWithTag('overbtn', res)
        this.$message.success('规则提前结束成功')
        setTimeout(() => {
          this.$router.push({
            name: 'CouponRuleList',
            query: {
              serverUniqueId: this.$route.query.serverUniqueId,
              updateFlag: true
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}
</style>